import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { BooleanToggle } from '../controls/boolean-toggle';
import type { SectionProps } from './types';

export const HeroSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <BooleanToggle
      label={t['com.streamlain.customApps.viewConfig.hero.label']()}
      description={t['com.streamlain.customApps.viewConfig.hero.desc']()}
      data-sl-field="hero"
      value={row.hero}
      onChange={v => setField('hero', v)}
    />
  );
};
